module.exports = __webpack_public_path__ + "media/images/favicon-a1902f613c3a1854bac9cdf72f8ea02d.png";